import { axiosInstance } from '../../utils';
import { AudioCredit } from '../../@types';

interface Payload {
  text: string;
  isAudioCreation: boolean;
}

export const getAudioCreditsEstimation = async (payload: Payload): Promise<AudioCredit> => {
  const res = await axiosInstance.post('/api/videos/required-credits', payload);
  return res.data;
};
